var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 7,
    viewBox: "0 0 17 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.727461 0.459999H3.01546L5.84946 3.372L3.01546 6.284H0.727461L3.56146 3.372L0.727461 0.459999ZM5.8777 0.459999H8.1657L10.9997 3.372L8.1657 6.284H5.8777L8.7117 3.372L5.8777 0.459999ZM11.0279 0.459999H13.3159L16.1499 3.372L13.3159 6.284H11.0279L13.8619 3.372L11.0279 0.459999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentIcon);
export default __webpack_public_path__ + "static/media/sent_icon.b70dee5e23ae9e213f934f540fc200a1.svg";
export { ForwardRef as ReactComponent };